import React from "react";

function ArrowDownUpIcon({ color = "#57606A", sortDirection = null }) {
  // Determine colors based on sort direction
  const upArrowColor = sortDirection === 'asc' ? color : color;
  const downArrowColor = sortDirection === 'desc' ? color : color;
  const upArrowOpacity = sortDirection === 'desc' ? 0.4 : 1;
  const downArrowOpacity = sortDirection === 'asc' ? 0.4 : 1;

  return (
    <>
      <svg
        width="14"
        height="14"
        viewBox="0 0 14 14"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        {/* Down arrow (left side) */}
        <path
          d="M6.43477 9.31581C6.47545 9.35644 6.50772 9.4047 6.52974 9.45781C6.55175 9.51092 6.56309 9.56785 6.56309 9.62534C6.56309 9.68284 6.55175 9.73977 6.52974 9.79288C6.50772 9.84599 6.47545 9.89424 6.43477 9.93488L4.68477 11.6849C4.64414 11.7256 4.59589 11.7578 4.54278 11.7798C4.48967 11.8019 4.43274 11.8132 4.37524 11.8132C4.31775 11.8132 4.26082 11.8019 4.20771 11.7798C4.1546 11.7578 4.10634 11.7256 4.06571 11.6849L2.31571 9.93488C2.27506 9.89423 2.24282 9.84597 2.22082 9.79286C2.19882 9.73975 2.1875 9.68283 2.1875 9.62534C2.1875 9.56786 2.19882 9.51094 2.22082 9.45783C2.24282 9.40472 2.27506 9.35646 2.31571 9.31581C2.3978 9.23372 2.50915 9.1876 2.62524 9.1876C2.68273 9.1876 2.73965 9.19892 2.79276 9.22092C2.84587 9.24292 2.89413 9.27516 2.93477 9.31581L3.93774 10.3193V2.62534C3.93774 2.50931 3.98384 2.39803 4.06588 2.31599C4.14793 2.23394 4.25921 2.18784 4.37524 2.18784C4.49128 2.18784 4.60256 2.23394 4.6846 2.31599C4.76665 2.39803 4.81274 2.50931 4.81274 2.62534V10.3193L5.81571 9.31581C5.85634 9.27514 5.9046 9.24287 5.95771 9.22085C6.01082 9.19883 6.06775 9.1875 6.12524 9.1875C6.18274 9.1875 6.23967 9.19883 6.29278 9.22085C6.34589 9.24287 6.39414 9.27514 6.43477 9.31581Z"
          fill={downArrowColor}
          opacity={downArrowOpacity}
        />
        {/* Up arrow (right side) */}
        <path
          d="M11.6848 4.06581L9.93478 2.31581C9.89414 2.27514 9.84589 2.24287 9.79278 2.22085C9.73967 2.19883 9.68274 2.1875 9.62524 2.1875C9.56775 2.1875 9.51082 2.19883 9.45771 2.22085C9.40459 2.24287 9.35634 2.27514 9.31571 2.31581L7.56571 4.06581C7.48362 4.14791 7.4375 4.25925 7.4375 4.37534C7.4375 4.49144 7.48362 4.60278 7.56571 4.68488C7.6478 4.76697 7.75915 4.81309 7.87524 4.81309C7.99134 4.81309 8.10268 4.76697 8.18477 4.68488L9.18774 3.68136V11.3753C9.18774 11.4914 9.23384 11.6027 9.31588 11.6847C9.39793 11.7668 9.50921 11.8128 9.62524 11.8128C9.74128 11.8128 9.85256 11.7668 9.9346 11.6847C10.0167 11.6027 10.0627 11.4914 10.0627 11.3753V3.68136L11.0657 4.68488C11.1478 4.76697 11.2591 4.81309 11.3752 4.81309C11.4913 4.81309 11.6027 4.76697 11.6848 4.68488C11.7669 4.60278 11.813 4.49144 11.813 4.37534C11.813 4.25925 11.7669 4.14791 11.6848 4.06581Z"
          fill={upArrowColor}
          opacity={upArrowOpacity}
        />
      </svg>
    </>
  );
}

export default ArrowDownUpIcon;
